import { Component, Inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import User from 'models/user/user.model';
import ProjectPermission from 'models/project-permission/project-permission.model';
import { ProjectService } from 'services/project/project.service';
import { UserService } from 'services/user/user.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-project-user-permissions',
  templateUrl: './project-user-permissions.component.html',
  styleUrls: ['./project-user-permissions.component.scss'],
})
export class ProjectUserPermissionsComponent {
  public projectPermission: ProjectPermission = new ProjectPermission();

  constructor(
    public projectService: ProjectService,
    public userService: UserService,
    public snackBar: MatSnackBar,
    private dialogRef: MatDialogRef<ProjectUserPermissionsComponent>,
    @Inject(MAT_DIALOG_DATA) data,
  ) {
    this.projectPermission.user = data.user;
    this.projectPermission.project = data.project;

    this.projectService.getPerms(data.project, data.user).then((permissions) => {
      this.projectPermission = permissions
      // this.projectPermission.user = data.user;
      // this.projectPermission.project = data.project;
    });
  }

  async save() {
    const newPerm = new ProjectPermission({
      id: this.projectPermission.id,
      project: this.projectPermission.project,
      user: this.projectPermission.user,
      delete: this.projectPermission.delete ? 1 : 0,
      update: this.projectPermission.update ? 1 : 0,
      workOn: this.projectPermission.workOn ? 1 : 0,
      updateSchema: this.projectPermission.updateSchema ? 1 : 0,
      updateLayers: this.projectPermission.updateLayers ? 1 : 0,
      updateArcgis: this.projectPermission.updateArcgis ? 1 : 0,
      manageUsers: this.projectPermission.manageUsers ? 1 : 0,
      updateTickets: this.projectPermission.updateTickets ? 1 : 0,
    });
    if (await this.projectService.updatePerms(newPerm)) {
        this.projectPermission = await this.projectService.getPerms(this.projectPermission.project, this.projectPermission.user);
        this.dialogRef.close();
    }
  }
}
